// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace ApiPromocodesSchema {
  export enum AssetType {
    Ton = "TON",
    Nft = "NFT",
  }

  export enum LockStatus {
    Locked = "LOCKED",
    Unlocked = "UNLOCKED",
  }

  export enum ErrorCode {
    NotFound = "promo_code_not_found",
    AlreadyUsed = "promo_code_already_used",
    RequirementNotMet = "promo_requirement_not_met",
    BudgetExceeded = "promo_budget_exceeded",
  }

  export interface RewardItem {
    id: string
    asset_type: AssetType
    amount?: number
    nft_id?: string
    large_image_url?: string
    lottie_animation_url?: string
    wagering_turnover?: number
    wagering_nft_bet?: boolean
  }

  export interface RewardLock {
    id: string
    redemption_id: string
    user_id: string
    asset_type: AssetType
    amount: number | null
    nft_id: string | null
    status: LockStatus
    required_turnover: number | null
    progress_turnover: number | null
    created_at: string
    unlocked_at: string | null
  }

  export interface Redemption {
    id: string
    campaign_id: string
    code_id: string
    code: string
    user_id: string
    reward_items: RewardItem[]
    reward_locks?: RewardLock[]
    created_at: string
  }
}
